/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'AI recension',
    AIReviewFailed: 'AI-granskning misslyckades',
    AIReviewPassed: 'AI-granskning godkänd',
    AIReviewStatus: 'AI granskningsstatus',
    AIReviewing: 'AI-granskning håller på att granskas',
    America: {},
    CheckSupportInstall: 'Kontrollera om eftermontering stöds',
    ImporterCommunityDisplayName: 'Visningsnamn för importörgemenskapen',
    ImporterContactEmail: 'Kontakt-e-post för importören',
    IndicatorLight: 'indikator ljus',
    Instruction: 'Lägga märke till',
    MostPicture4OrVideo: '(Högst 4 bilder / 1 video)',
    PleaseContactPersonnelCommunicating: 'Kontakta CFMOTOs personal för kommunikation',
    Redemptionservice: 'Inlöst tjänst',
    USD: {},
    UnbindingApplicationCommitment: {},
    aboutAccount: 'Om kontot',
    aboutVehicle: 'Om fordonet',
    accountApplyRejected: 'Begäran om radering av konto avvisad',
    accountCancel: 'Begäran om radering av konto',
    accountDeletExplain: 'Guide för borttagning av konto',
    accountDelete: 'Ta bort konto',
    accountDeleted: 'Konto borttaget',
    accountFormatError: 'Felaktigt kontoformat/användare finns inte. Vänligen matcha motsvarande text baserat på den faktiska orsaken',
    accountNumber: 'Kontonummer',
    action: 'Operation',
    actionFail: 'operationen misslyckades',
    actionSuccess: 'Åtgärden lyckades',
    activeScore: 'Aktiv poängsättning',
    activeTrigger: 'Användare utlöser aktivt (Om APP – Gå till betyg)',
    activity: 'Aktivitet',
    activityCancel: 'Avbokning av evenemang',
    activityCover: 'Omslag till evenemanget',
    activityDetails: 'Aktivitetsdetaljer',
    activityId: 'Aktivitets-ID',
    activityList: 'Lista över aktiviteter',
    activityManagement: 'Hantering av evenemang',
    activitySearch: 'Aktiv sökning',
    activityTime: 'Tid för händelse',
    activityTitle: 'Evenemangets titel',
    activityVenue: 'Plats för evenemanget',
    adaptable: 'För',
    add: 'Lägg till',
    addAccountDeletExplain: 'Lägg till meddelande om borttagning av konto',
    addAuthenticationTime: 'Tid för tillägg av autentisering',
    addCanadaPrivacyPolicy: 'Lägg till Kanadas sekretesspolicy',
    addCanadaTelematicsPolicy: 'Lägg till Canada Telematics Agreement',
    addCanadaUserPolicy: 'Lägg till kanadensiskt användaravtal',
    addDashcamHelp: 'Tillagd Dashcam Hjälp',
    addDataDeletExplain: 'Lägg till meddelande om borttagning av data',
    addEmail: 'Ny E-post',
    addExhibitionCategory: {},
    addExhibitionSeries: {},
    addHelpConfiguration: 'Lägg till hjälpinstruktioner för konfiguration',
    addInformationCategory: 'Lägg till ny informationskategori',
    addInformationContent: 'Lägg till nytt informationsinnehåll',
    addKolUserAuthentication: 'Lägg till autentisering för KOL-användare',
    addPicture: 'Lägg till bild',
    addPrivacyAgreement: 'Lägg till sekretessavtal',
    addPrivacySubmitSure: 'Ikraftträdandedatumet och ändringsbeskrivningen av den nya integritetspolicyn kan inte justeras efter inlämning. Bekräfta inlämningen.',
    addPushConfiguration: 'Lägg till pushkonfiguration',
    addQuestion: {},
    addSdkStaement: 'Lägg till SDK-utlåtande',
    addServiceIntroduce: 'Introduktion till nya tjänster',
    addShowroomModel: 'Lägg till utställningsmodeller',
    addThisUser: 'Lägg till den här användaren',
    addTopic: 'Lägga till ett ämne',
    addUser: 'Lägga till användare',
    addUserAgreement: 'Lägg till användaravtal',
    addUserRole: 'Lägg till användarroll',
    addVehicleModel: 'Nya modeller',
    addVehicleModelCategory: 'Ny fordonskategori',
    addVideo: 'Lägg till video',
    addedBy: 'Tillagd av',
    additionalFeedback: 'Ytterligare feedback',
    administratorUnbind: 'Administratör avbinder',
    afternoon: 'eftermiddag',
    agreeServiceAgreement: 'Genom att aktivera tjänsten godkänner du tjänsteavtalet',
    agreeSignOut: 'Överenskommet att avsluta',
    agreementContent: 'Avtal',
    all: 'Hela',
    allArea: 'Målland/region',
    allComment: 'Alla kommentarer',
    allImportSuccess: 'Import slutförd. Alla importerade framgångsrikt',
    allServicesSimultaneously: 'Alla tjänster',
    allUser: 'Alla användare',
    allVehicleModel: 'Alla modeller',
    alreadyOver: 'Allt här inne',
    ambientLightControl: 'Kontroll av stämningsbelysning',
    amount: 'Belopp',
    android: 'Android',
    answer: {},
    answerOta1: 'OTA innebär att fordonet laddar ner den senaste firmwareprogramvaran från molnet via mobilnätverket, och du kan uppgradera fordonet online via CFMOTO RIDE för att kontinuerligt optimera körupplevelsen',
    answerOta2: 'När ny version av tft-skärmen som kan uppgraderas får du uppgraderingsmeddelandet. Om %s visas längst ner på den aktuella sidan betyder det att fordonets tft-display inte behöver uppgraderas.',
    answerOta3: 'Du kan klicka på %s i det övre högra hörnet för att lära dig mer OTA-instruktioner i förväg',
    anyCar: 'Har du bil?',
    appMessagePushCountLimit: 'Du har nått push-gränsen för den här månaden (2 gånger/månad). Det redigerade innehållet kan sparas som ett utkast. Vill du spara det?',
    appPush: 'App-push',
    appRating: 'Hantering av poängmekanism',
    appType: 'Telefonsystem',
    appVersion: 'APP-version',
    applicableCountry: {},
    applicableCountryName: {},
    applyTime: 'Tid för ansökan',
    applyUnbinding: 'Tillämpa avbindning',
    appointmentReleaseTime: 'Utnämningstid',
    approval: 'Godkännande',
    arrivalNumberDescription: 'Antal enheter som mottog aviseringen',
    arrivalNumberDescription0: 'Det faktiska antalet ankomster till enhetens terminal efter att avisningsmeddelandet har skickats (ankomster efter 5 dagar kommer inte att räknas)',
    arrivalNumberVolume: 'Antal ankomster',
    askAllowUserSpeakInCommunity: 'Vill du tillåta en blockerad användare att göra inlägg i communityn',
    askApproveIt: 'Godkänna det',
    askDeleteCategory: {},
    askDeleteInformactionCategory: 'Om denna informationskategori ska raderas',
    askDeleteInformationContent: 'Om informationsinnehåll ska raderas',
    askDeleteKolUserAuthentication: 'Är du säker på att du vill ta bort denna KOL-användarautentisering?',
    askDeleteOfficialAuth: 'Är du säker på att du vill ta bort officiell autentisering för det här kontot?',
    askDeleteQuestion: {},
    askDeleteThisActivity: 'Vill du ta bort den här aktiviteten',
    askDeleteThisBanner: 'Vill du ta bort den här Banner',
    askDeleteThisComment: 'Är du säker på att du vill ta bort den här kommentaren',
    askDeleteThisPost: 'Ta bort det här inlägget',
    askDeleteThisTopic: 'Vill du ta bort det här avsnittet',
    askDeleteVehicleType: 'Är du säker på att ta bort fordonsmodellen',
    askDeleteVehicleTypeCategory: 'Om denna modellkategori ska tas bort',
    askDeleteVehicleTypeDetails: 'Om detaljerna för bilmodellen ska raderas',
    askDeleteVehicleTypeSeries: 'Om denna modellserie ska tas bort',
    askLogout: 'Är du säker på att du vill avsluta systemet?',
    askNotApproveIt: 'Godkänner du det inte',
    askSaveSettings: 'Inställningarna har inte sparats än, vill du spara dem?',
    associatedPostNumber: 'Antal relaterade inlägg',
    associatedPosts: 'Relaterade artiklar',
    associatedVehicle: 'tillhörande fordon',
    assoclatedContent: 'Associerat innehåll',
    atmosphereCContent: 'Inställningarna har inte sparats än, vill du spara dem?',
    atmosphereContent1Msg1: 'När funktionen är påslagen slår mobiltelefonen på Bluetooth och APP fortsätter att köra. När du närmar dig fordonet långt till nära kan fordonet automatiskt låsas upp och slås på.',
    atmosphereContent1Msg2: 'Om den normalt inte är olåst och påslagen trycker du på fordonets strömknapp för att låsa upp och slå på',
    atmosphereContent1Msg3: 'Automatisk upplåsning av närhet utlöses bara en gång innan Bluetooth kopplas bort',
    atmosphereContent2Msg1: 'Efter att funktionen har slagits på stängs fordonet automatiskt av efter 5 sekunder efter att fordonets tre förhållanden har stängts av, fordonets hastighet är 0 och templet tappas',
    atmosphereContent2Msg2: 'Starta fordonet under den automatiska avstängningsperioden, fordonets hastighet är inte 0, eller templet läggs bort kommer att avbryta den automatiska avstängningen',
    atmosphereContent3Msg1:
      'När funktionen är påslagen, när fordonet stängs av, slår mobiltelefonen på Bluetooth och APP: n fortsätter att köra eller bär den fysiska nyckeln. När du närmar dig fordonet långt till nära blinkar fordonets lampor för att välkomna gästerna',
    atmosphereContent3Msg2: 'För att förhindra att frekventa utlösare orsakar fordonets strömförlust, efter att välkomstfunktionen har utlösts två gånger inom 30 sekunder, återupptas den inte förrän 30 minuter senare',
    atmosphereContent4Msg1: 'Efter att funktionen har slagits på kommer fjärr- och halvljusljusen att tändas automatiskt i 10 sekunder efter att fordonet stängts av',
    atmosphereIntroduce1: 'Instruktioner för nära automatisk upplåsning',
    atmosphereIntroduce2: 'instruktioner för automatisk avstängning',
    atmosphereIntroduce3: 'Instruktioner för automatisk väckning',
    atmosphereIntroduce4: 'Fördröjda lampor släcks',
    atmosphereSetINfo: 'De nya inställningarna kommer att träda i kraft inom 1-3 minuter efter att fordonet slås på, se till att fordonet är i en bra signalposition',
    auditStatus: 'Granskningsstatus',
    authType: 'Autentiseringstyp',
    authenticatedName: 'Autentiserat namn',
    avatar: 'Avatar',
    backApply: 'dra tillbaka ansökan',
    backApplySuccess: 'återkallelse av ansökan framgångsrikt',
    backHome: 'Tillbaka till hemsidan',
    bannerDisplayImages: 'Banner bild',
    bannerList: 'Lista över banners',
    bannerManagement: 'Hantering av bannerannonser',
    bannerPictrure: 'Banderoll ritning',
    bannerSearch: 'Sökning efter banner',
    bannerTitle: 'Bannertitel',
    baseService: 'Standard Edition\n',
    baseServicePay: 'Betalning för Standard Edition',
    baseServiceResetTimeRule: 'Återställningstid för bastjänsten kan inte vara senare än den aktuella tiden',
    batchImport: 'Batch-import',
    batchUser: 'Batchanvändare',
    beijingTime: 'UTC+8 tid',
    belogCategory: 'kategori',
    belongCategory: {},
    bindDevice: 'Bind enhet',
    bindEmail: 'Binda e-post',
    bindVehicle: 'Bind fordon',
    bindingStatus: 'Bindande status',
    bindingText1: '1.\tTelematiktjänster _',
    bindingText10: '1.1.2.\tTillhandahålla ruttplanering under navigering, inklusive beräkning av avståndet mellan fordon och gångnavigering i syfte att hitta ett fordon .',
    bindingText11: '1.2.\tSkicka nödvändiga aviseringar till kunden baserat på fordonets skick.',
    bindingText12: '1.2.1.\tCFMOTO kommer att avsluta kundens meddelanden om fordonsunderhåll (t.ex. baserat på den totala sträckan som kunden kör, tidpunkten när kunden köper fordonet, tiden eller kraven på körsträcka för fordonsunderhåll) .',
    bindingText13: '1.2.2.\tBaserat på fordonsdata kommer CFMOTO att skicka meddelanden om onormal situation till kunden ; inklusive dataanalys av OEM (beroende på modell) för att ge kundvård och uppföljningsoptimering av fordonet .',
    bindingText14: '1.3.\tStöd vid analys av orsaken till olyckan om Kunden rapporterar en allvarlig olycka med Fordonet.',
    bindingText15:
      '1.3.1.\tI händelse av en allvarlig olycka med Fordonet, såsom när Fordonet välter eller välter på sidan under körning, kommer CFMOTO att stödja Kunden på begäran med att klargöra om olyckan beror på en defekt i Fordonet eller andra omständigheter. Begäran ska skickas till CFMOTO av kunden via den lokala distributören/försäljningspartnern som anges i fordonsförsäljningsavtalet.',
    bindingText16: '1.3.2.\tI den mån tillgängliga data tillåter detta kommer CFMOTO att utvärdera uppgifterna i förhållande till orsaken till olyckan och förse Kunden med en motsvarande rapport.',
    bindingText17: '1.4.\tAssistans för kunden att återställa Fordonet efter att Fordonet har förlorats .',
    bindingText18:
      '1.4.1.\tOm Fordonet försvinner kommer CFMOTO att förse Kunden med lokaliseringsdata för Fordonet och annan användbar statusdata för Fordonet (såsom plats för senaste aktivering, aktuell fordonsstatus, etc.) på begäran och om tillgänglig.',
    bindingText19: '1.4.2.\tBegäran ska skickas till CFMOTO av kunden via den lokala distributören/försäljningspartnern som anges i fordonsförsäljningsavtalet.',
    bindingText2:
      'CFMOTO Powersports, Inc. (hädanefter kallat " CFMOTO " ) tillhandahåller fordonstelematiktjänster till kunden som köpte CFMOTO-fordonet (nedan kallat "Kund" ). För dessa tjänster använder CFMOTO data som registrerats av Fordonet om Fordonet och dess körbeteende under den relevanta tidsperioden. I detalj handlar det om följande data:',
    bindingText20: '1.5.\tRapportering av eftermarknadsproblem .',
    bindingText21: '1.5.1.\tCFMOTO samlar in felkodsmeddelanden på distans som skickas av Fordonet i händelse av fel på dess komponenter och tillhandahåller respektive information på Kundens begäran direkt till Kunden.',
    bindingText22: '1.5.2.\tBegäran ska skickas till CFMOTO av kunden via den lokala distributören/försäljningspartnern som anges i fordonsförsäljningsavtalet.',
    bindingText23: '2.\tBegränsningar och undantag för tjänsten',
    bindingText24:
      '2.1.\tDet påpekas uttryckligen att strukturella eller andra tekniska förändringar av Fordonet kan begränsa tillhandahållandet av tjänsterna eller till och med göra det omöjligt, eftersom tjänsterna är beroende av korrekt tillhandahållande av fordonsdata.',
    bindingText25: '2.2.\tDär sådana tjänster inte kan tillhandahållas på grund av prestanda hos någon tredje parts data- eller telekommunikationsnätverk, är CFMOTOs ansvar uteslutet.',
    bindingText26: '3.\tIntegritet',
    bindingText27:
      'CFMOTO kommer att följa gällande dataskyddsbestämmelser vid behandling av personuppgifter i samband med CFMOTO- fordonet . Villkoren för C FMOTOs integritetspolicy anges i denna CFMOTO RIDE- APP. Som ett komplement till integritetspolicyn överensstämmer hans meddelande med integritetspolicyn . Och kunden kan hänvisa till integritetspolicyn för visst databehandlingsrelaterat innehåll som inte täcks av detta meddelande.',
    bindingText28: '4.\tKundservice',
    bindingText29:
      '4.1.\tKunden kan gärna skicka sekretessrelaterade frågor , kommentarer eller bekymmer till CFMOTORIDEAPP@cfmotousa.com eller skriva till: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Kunden kan också ringa CFMOTO kundrelationer på (888) 823-6686. ',
    bindingText3: 'Data om användarens körbeteende : inklusive acceleration, retardation, hastighet, böjning, senaste körtid och senaste körsträcka .',
    bindingText30: '5.\tR evisioner',
    bindingText31: '5.1.\tCFMOTO förbehåller sig rätten att ändra detta meddelande när som helst, men vi kommer att publicera revisioner på CFMOTO RIDE App och/eller meddela innan vi gör det på lämpligt sätt.',
    bindingText4:
      'Fordonsstatusdata: hänvisar till fordonets status i realtid, inklusive körläge, restbränsle, omedelbar bränsleekonomi, körsträcka, fordonets växel i realtid, motorvarvtal, däcktryck, däcktemperatur, batteriaktiveringsspänningsdata , kylvätsketemperatur, elektroniskt låsstatus, intelligent enhets mjukvaruversion, signalstyrka för smarta enheter, aktuell inställning av instrumentbrädan.',
    bindingText5:
      'Fordonslarmdata: larmdata som ska skickas om vissa data överskrider ett förinställt värde, såsom motortemperatur, för hög hastighet, för lång körtid, hög kylvätsketemperatur, onormala fordonsrörelser, onormalt däcktryck, vibrationer, dumpning, kollision , etc. .',
    bindingText6: 'Fordonsfelinformation: hänvisar till de felkoder som rapporteras av varje intern del av fordonet.',
    bindingText7: 'Fordonsplatsdata: hänvisar till fordonets specifika geografiska vistelseort.',
    bindingText8: '1.1.\tTillhandahålla ing kunden med fordonsrelaterade tjänster genom CFMOTO RIDE APP .',
    bindingText9: '1.1.1.\tKonsumenterna kan fjärrstyra fordon via CFMOTO RIDE APP (inklusive att visa fordonsplatsen, ställa in fordonsinformation och funktioner, fjärrkontroll av fordonsstatus, etc.).',
    bindingUser: 'Koppla användare',
    bothServices: 'Båda tjänsterna',
    bound: 'Bunden',
    businessType: 'Affärstyp',
    button: 'Knapp',
    callbackedApply: 'Du har dragit tillbaka din ansökan om borttagning av konto på yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      'Din Riktlinjer för borttagning av konto skickades in den yyyy-MM-dd HH:mm:ss. Ditt konto och relaterade data kommer att raderas permanent 15 dagar efter att vi mottagit din begäran. Efter raderingen kommer du inte längre att kunna använda CFMOTO RIDESYNC-tjänsten. För att avbryta Riktlinjer för borttagning av konto, besök webbsidan igen eller logga in på APP:en inom 15 dagar för att återkalla din begäran om radering.',
    callbackedApplyTip:
      'Din Riktlinjer för borttagning av konto skickades in den yyyy-MM-dd HH:mm:ss. Ditt konto och relaterade data kommer att raderas permanent 15 dagar efter att vi mottagit din begäran. Efter raderingen kommer du inte längre att kunna använda CFMOTO RIDE-tjänsten. För att avbryta Riktlinjer för borttagning av konto, besök webbsidan igen eller logga in på APP:en inom 15 dagar för att återkalla din begäran om radering.',
    canadaPrivacyPolicy: 'Kanadas sekretesspolicy',
    canadaTelematicsPolicy: 'Kanadas telematikavtal',
    canadaUserPolicy: 'Kanadensiskt användaravtal',
    canadianAgreementText: 'Kanadensisk avtalstext',
    cancel: 'Avbryt',
    cancellationAgreement: 'Avbeställningsavtal',
    cancelled: 'Inställt',
    carOwner: 'Ägare',
    carUserScore: 'Fordonsägares betyg',
    cardPass: 'Identitetsverifieringen har lyckats!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Byt till Captcha-verifiering',
    changeDescriptionType: 'ändra beskrivning',
    changeDescriptionTypeSelectNo: 'Innebär inte ändringar i reglerna för behandling av personuppgifter',
    changeDescriptionTypeSelectYes: 'Förändringar i regelverk som innebär behandling av personuppgifter',
    changeEmail: 'Ändra e-post',
    changeEmailInfo: 'Byt till e-post',
    changeFail: 'Statusändring misslyckades',
    changeOne: 'Förändra',
    changePassValidate: 'Växla till lösenordsverifiering',
    changePasswordFailed: 'Det gick inte att byta lösenord',
    changePasswordSuccessful: 'Lösenordsändringen lyckades',
    changePhoneInfo: 'Byt till telefonnummer',
    changeStore: 'Ändra butik',
    changeSuccess: 'Status har ändrats',
    channelType: 'feedbackkanal',
    characterLimitExceeded: 'Teckengräns överskriden',
    checkConfigurationTwo: 'Kinesiska eller engelska %s är inte helt konfigurerade, kontrollera',
    checkCopyWriting: 'Det kinesiska eller engelska innehållet är inte ifyllt, vänligen kontrollera',
    checkEmpty: '%s är tomt, kontrollera',
    checkEmptyEnglish: 'Engelskan är ofullständig. Kontrollera',
    checkTriggerType: 'Det finns ett tillstånd för utlösningsmekanismen som inte har fyllts i, vänligen kontrollera',
    checkUpdate: 'kolla uppdateringarna',
    cityFilter: 'Stadsfilter',
    clickImmediateFeedback: 'Klicka för att ge feedback nu',
    clickNumber: 'Antalet klick',
    clickNumberDescription: 'Antal aviseringar som klickades på av användare',
    clickNumberVolume: 'Antal klick',
    clickToFeedback: 'Klicka för att få återkoppling',
    clicks: 'Klicka',
    closeNum: 'stängning',
    closeTask: 'Uppgiften avbruten',
    code: 'Verifieringskod',
    colorPicture: 'Färgblocksbild',
    comment: 'Kommentar',
    commentContent: 'Kommentarer',
    commentList: 'Lista över recensioner',
    commentNumber: 'Antal kommentarer',
    commentTime: 'Tid för kommentarer',
    communication: 'i kommunikation',
    community: 'Gemenskap',
    communityManagement: 'Förvaltning av gemenskaper',
    communityRule: 'Regler för communityn',
    completePuzzle: 'Vänligen fyll pusslet',
    completed: 'avslutad',
    condition: 'skick',
    configureLanguage: 'Konfigurera språk',
    configurePicture: 'Konfigurera bilden',
    confirm: 'Bekräfta',
    confirmDeletePictures: 'Bekräfta för att ta bort den här bilden',
    confirmRedeem: 'Bekräfta inlösen',
    confirmReviewNoPass: 'Bekräfta misslyckande med granskningen',
    confirmReviewPass: 'Bekräfta godkännande av granskningen',
    consultDealer: 'Kontakta din lokala återförsäljare',
    contact: 'Din ansökan om borttagning av konto har avvisats. Om du har några frågor, vänligen kontakta it@cfmoto.com för konsultation.',
    contactMail: 'E-postadress',
    contactMethod: 'Kontakt',
    contactUs: 'Kontakta oss',
    content: 'Innehåll',
    contentType: 'Typ av innehåll',
    copyFail: 'Kopieringen misslyckades',
    copyLink: 'Kopiera länk',
    copySuccess: 'Kopierat framgångsrikt',
    copyWriting: 'Popup-innehåll',
    country: 'Land/region',
    countryCode: 'Landskod',
    countryName: 'Land',
    countryNumber: 'Landskod',
    countryRegion: 'Land/region',
    create: 'Nytt tillägg',
    createBy: 'Skapare',
    createStore: 'Skapa butik',
    createTime: 'skapande tid',
    cs_CZ: 'tjeckiska',
    currency: 'Valuta',
    currentConfig: {},
    currentCountryStoreTotal: 'Totalt antal butiker i det aktuella landet',
    currentRedemptionRatio: 'Aktuell inlösenkurs',
    currentTime: 'Den aktuella tiden',
    customPage: 'Anpassad sida',
    customSettings: 'Anpassade kolumner',
    dashcamHelp: 'Dashcam Hjälp',
    dataDeletExplain: 'Guide för borttagning av data',
    dataDelete: 'Ta bort data',
    dataDeleteApply: 'Begäran om radering av data',
    dataFormatError: 'Dataformatfel',
    dataPermissionScope: 'Datatillståndsomfång',
    dataType: 'Typ av data',
    dayOne: 'dagar en gång',
    days: 'dag',
    daysAgo: '%s dagar sedan',
    de_DE: 'tysk',
    dealDate: 'Handläggningstid',
    dealerOperationList: 'Återförsäljarens operationer lista',
    dealerOperationQuery: 'Återförsäljarens driftfråga',
    dealerOperationRecord: 'Åtgärdslogg för återförsäljare',
    dealerStore: 'Återförsäljarbutiker',
    dealerStoreImportTempateName: 'Mall för import av återförsäljarbutik',
    dealerStoreQuery: 'Förfrågan om återförsäljarbutiker',
    dealers: 'Importör',
    default: 'Standard',
    defaultMap: 'Standardkarta',
    delete: 'Radera',
    deleteAccountSYNCStep: 'Du kan begära radering av ditt CFMOTO RIDESYNC-konto genom att följa dessa steg',
    deleteAccountStep: 'Du kan begära radering av ditt CFMOTO RIDE-konto genom att följa dessa steg',
    deleteDataSYNCStep: 'Du kan begära radering av dina CFMOTO RIDESYNC-data genom att följa dessa steg',
    deleteDataStep: 'Du kan begära radering av dina CFMOTO RIDE-data genom att följa dessa steg',
    deleteFail: 'Raderingen misslyckades',
    deleteFinish: 'Borttagningen slutförd',
    deleteKolUserAuthentication: 'Ta bort autentisering för KOL-användare',
    deleteStore: 'Ta bort butik',
    deleteSuccess: 'Raderingen lyckades',
    deleteTip: 'Är du säker på att du vill ta bort det här inlägget? När informationen väl raderats kan den inte återställas',
    deleteVersionWarn: 'Om denna versionspost ska raderas',
    deleteVideo: 'Vill du ta bort den här videon?',
    detailAddress: 'Detaljerad adress',
    details: 'Detaljer',
    determine: 'Säker',
    deviceCodeGet: 'Hämta enhetskod:',
    deviceContent:
      'Den elektroniska stängselmottagaren (kallad: nyckel) utrustningskoden är en sträng med 10-siffriga koder. Utrustningskoden, QR-koden och CE-märkningen är tryckta på den självhäftande PVC-dekalen i silver. Det finns tre etiketter totalt, en har fästs på fordonets kaross (du måste lyfta sittdynan för att se); de andra två placeras i fordonets tillbehörsväska. (Det rekommenderas att användare fäster etiketten på fordonets manual eller på fjärrkontrollen)\nVänligen tryck och håll in PÅ för att öppna nyckeln och lägg in QR-koden på baksidan av nyckeln i skanningsramen',
    deviceNo: 'Tillhörande enhetsnummer',
    deviceNumber: 'Enhetsnummer',
    deviceTitle: 'Kontroll av enhetskod',
    digitalKey: 'digital nyckel',
    digitalKeyDesc: 'Inget behov av att bära en fysisk nyckel, stödjer upplåsning av fordonet efter anslutning via APP Bluetooth (stöds av vissa modeller)',
    directRelease: 'Direkt publicering',
    disagree: 'Inte överens',
    displayNumberDescription: 'Antal aviseringar som visades på enheterna',
    displayNumberVolume: 'Antal visningar',
    displayOrder: {},
    displayPicture: {},
    donwloadTemplateDescription: {},
    download: 'Ladda ner',
    downloadFailFile: 'Ladda ner misslyckad fil',
    downloadSuccessful: 'Nedladdningen lyckades',
    downloadTemplate: 'Ladda ner mall',
    downloading: 'Laddar ned...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'redigera',
    editAccountDeletExplain: 'Redigera meddelande om borttagning av konto',
    editActivity: 'Redigera aktiviteten',
    editAppRating: 'Redigera betygsmekanism',
    editBanner: 'Redigera banderollen',
    editCanadaPrivacyPolicy: 'Redigera Kanadas sekretesspolicy',
    editCanadaTelematicsPolicy: 'Redigera Kanadas telematikavtal',
    editCanadaUserPolicy: 'Redigera Kanadas användaravtal',
    editDashcamHelp: 'Redigerad Dashcam Hjälp',
    editDataDeletExplain: 'Redigera meddelande om borttagning av data',
    editExhibitionCategory: {},
    editExhibitionSeries: {},
    editFunctionIntro: {},
    editHelpConfiguration: 'Redigera konfigurationen av hjälpinstruktionerna',
    editInformation: 'Redigera information',
    editInformationCategory: 'Redigera informationskategori',
    editInformationContent: 'Redigera informationsinnehåll',
    editKolUserAuthentication: 'Redigera autentisering för KOL-användare',
    editModelSeries: 'Redigera modellserie',
    editPicture: 'Redigera bild',
    editPushConfiguration: 'Redigera pushkonfiguration',
    editRemark: 'Redigera anteckningar',
    editServiceIntroduce: {},
    editShowroomModel: 'Redigera utställningsmodeller',
    editSuccess: 'Redigerades framgångsrikt',
    editTime: 'Redigeringstid',
    editUnbindingCommitment: {},
    editUser: 'Redigera användare',
    editVehicleModel: 'Redigera modell',
    editVehicleModelCategory: 'Redigera fordonskategor',
    effecting: 'Pågående aktivering',
    effectiveTime: 'Ikraftträdande datum',
    electricVehicle: 'Elektriskt fordon',
    email: 'E-mail',
    emailAdress: 'E-postadress',
    emailAdressTip: 'Observera:  Denna e-postadress används för att kontakta kunder via e-post.  Se till att din e-postadress är korrekt',
    emailBindingFailed: 'E-postlåsning misslyckades',
    emailContent: 'Innehåll i e-post',
    emailImportTemplate: 'Importmall för e-postadresser',
    emailImportTemplateToDownLoad: 'E-postadresser kan importeras i omgångar, klicka för att ladda ner',
    emailList: 'E-postlista',
    emailManage: 'E-posthantering',
    emailMass: 'E-post Blast',
    emailSearch: 'E-postfråga',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'E-post',
    emailTitle: 'Ämne',
    en_US: 'engelsk',
    enableStatus: 'Aktiverad status',
    enabled: 'Gör det möjligt',
    endTime: 'Sluta tid',
    endTimeLargeStartTime: 'Sluttid måste vara senare än starttid',
    enterAnswer: {},
    enterCategory: {},
    enterCodeToSafeAccount: 'För att garantera säkerheten för ditt konto ska du bekräfta din kontoinformation du vill radera och ange ditt lösenord eller verifieringskod för att verifiera din identitet.',
    enterCodeToSafeData: 'För att garantera säkerheten för dina uppgifter, vänligen bekräfta din kontoinformation och ange ett lösenord eller en verifieringskod för att verifiera din identitet.',
    enterIntroduceText: {},
    enterLink: {},
    enterPopupTitle: {},
    enterQueryConditionLookData: 'När du har angett frågevillkoren kan du se data',
    enterQuestion: {},
    enterQuestionAndAnswer: {},
    enterSureUrl: {},
    enterTypeOfLanguage: {},
    enterUnbindingCommitment: {},
    entrance: {},
    errorLatAndLon: 'Latituden och longituden är felaktigt formaterade, vänligen kontrollera',
    errorLocation: {},
    es_ES: 'spanska',
    estimatedTime: 'Beräknad tid',
    everySet: 'Per inställning',
    examineResultMessage: 'Vi kommer att verifiera applikationsmaterialet så snart som möjligt, var uppmärksam på meddelandefältet eller APP-meddelandecentret i tid.',
    example: 'prejudikat',
    exchange: 'Lös in nu',
    exchangeDescription1:
      'Kära CFMOTO-ägare, ditt fordon har kopplats till ditt konto. Du har fått ett års gratis provperiod för intelligenta tjänster. \nVälj vilka tjänster du vill aktivera:\n- Standardversion\n- MotoPlay Premium\nLäs och godkänn användarvillkoren\nVisa "Avtal för intelligenta tjänster”\n[Bekräfta]\t',
    exchangeDescription2:
      'Vänligen kontrollera e-manualen för fullständig fordonsinformation. Du får även ett års kostnadsfri testperiod för alla CFMOTO RIDE:s intelligenta tjänster, med start från datumet för första ihopkopplingen.\n[Stäng] [Jag förstår]',
    exchangeDescription3:
      'Du har XXX km tillgänglig körsträcka. Lös in nu för att fortsätta använda CFMOTO RIDE:s intelligenta tjänst. Om ingen åtgärd vidtas sparas dina kördata i 30 dagar efter att kontot har kopplats bort. Ej inlöst körsträcka rensas automatiskt efter denna period och kan inte återställas. \nÄr du säker på att du vill lösa in nu?\n[Ja] [Nej] \n\n*Förmåner från inlöst körsträcka överförs till nästa ägare tillsammans med fordonet.',
    exchangeDescription4: 'Du har XXX km tillgänglig körsträcka. Vill du lösa in din körsträcka för att fortsätta \nnjuta av CFMOTO RIDE:s intelligenta tjänst kostnadsfritt?\n[Ja] [Nej]',
    exchangeDescription5:
      'Meddelande om intelligenta tjänster\nKära CFMOTO-ägare, Du har XXX dagar kvar av din kostnadsfria testperiod för CFMOTOs intelligenta tjänster. Om du aktiverar tjänsten kommer den att vara igång inom 24 timmar. Vänligen håll utkik efter bekräftelse.\n[Bekräfta]',
    exchangeDescription6: 'Få en bättre körupplevelse med MotoPlay, som erbjuder skärmspegling och navigering med stöd från Google Maps',
    exchangeRecords: 'Inlöshistorik',
    exchangeServiceTime: 'Du har tillgänglig körsträcka som kan lösas in för servicetid',
    exchangeSuccess: 'Inlösen lyckades',
    exhibition: {},
    exhibitionCategory: {},
    exhibitionCategoryList: {},
    exhibitionCategorySearch: {},
    exhibitionSeries: {},
    exhibitionSeriesList: {},
    exhibitionSeriesSearch: {},
    exportContent: 'Exportera ditt innehåll',
    exportExcel: 'Exportera till Excel',
    exportLengthExceedOfMonth: 'Exportlängden får inte överstiga %s månader',
    externalLink: 'Extern länk',
    failed: 'Misslyckades',
    failedToPreview: 'Granskning misslyckades',
    feedBackResut: 'Resultat av återkoppling',
    feedBackTime: 'Tid för återkoppling',
    feedBackVechle: 'Fordon',
    feedbackAppQuestion: 'Beskriv i detalj tidpunkten då problemet inträffade, APP-versionen, mobiltelefonmodellen, driftsvägen och problembeskrivningen så att vi snabbt kan lokalisera och felsöka problemet!',
    feedbackDetails: 'Feedback detaljer',
    feedbackGuideDesc: 'För mer information, vänligen kontakta oss via feedbackkanalen nedan',
    feedbackLabelFileList: 'Ladda upp en bild',
    feedbackMapQuestion: {},
    feedbackMessageSubmitError: 'Återkoppling misslyckades',
    feedbackOtherQuestion: 'Beskriv när det hände, hur det hände och vilket problem det rörde sig om.',
    feedbackReceived: 'Mottagen feedback',
    feedbackRecord: 'Återkopplingsprotokoll',
    feedbackRulesFileListMaxSize: 'Den uppladdade filen är för stor',
    feedbackRulesFileListOverType: 'Format som inte stöds',
    feedbackSubmitTip: 'Om du har några frågor eller kommentarer kan du också kontakta CFMOTO Mexico Customer Service Center direkt via WhatsApp (+52 18115286003) eller e-post (servicioalclient@cfmoto.com.mx)',
    feedbackSuggest: 'Välkommen att lämna värdefulla förslag, vi kommer att ta dina idéer på allvar.',
    feedbackSupplement: 'Lägg till en beskrivning av problemet',
    feedbackText: 'Återkoppling',
    feedbackType: 'Feedbacktyp (enkelval)',
    feedbackVehicleQuestion: 'Beskriv när det hände, hur det hände och vilket problem det rörde sig om.',
    female: 'Kvinna',
    fileCountExceed: 'Antalet filer överstiger gränsen',
    fileSizeExceed: 'Filstorleken överskrider gränsen',
    fileUploadingPleaceWait: 'Filen laddas upp, vänta',
    finalOperator: {},
    firstBindDate: 'Tidpunkt för Första Fordonets Bindning',
    firstMenu: 'Meny på första nivån',
    forcedUpgrade: 'Tvingad uppdatering',
    forgetPassword: 'Glöm lösenord',
    fourCarOfNumber: 'Antal användare av fyrhjuliga fordon',
    fourWheel: 'Fyrhjuliga motorcyklar',
    fourWheelConfig: {},
    fourWheeler: 'Fyrhjuling',
    fourWheelerMostClicks: 'Fyrhjuliga fordonsmodeller med flest klick',
    fourWheelowner: {},
    fr_FR: 'franska',
    frankfurt: 'Frankfurt',
    freeLastDayBasedata: 'Standardutgåva Kostnadsfri Varaktighet',
    freeLastDayMotoplay: 'Motoplay Kostnadsfri Varaktighet',
    friday: 'Fredag',
    fuctionIntro: {},
    fullscreen: 'Fullskärm',
    funServiceIntro: {},
    function: 'Fungera',
    functionConfiguration: {},
    functionConfigureTip: 'Den här funktionen är endast tillgänglig för konfigurerade fordon under importörens eller användarnamnet i det landet',
    functionDescription: {},
    functionDetail: {},
    functionIntroduce: 'Funktionsbeskrivning',
    functionSetting: {},
    functionalOverview: 'Översikt över funktioner',
    galleryEntrance: 'Galleri entré',
    galleryEntranceUploadRules: 'Formatkrav: jpg/jpeg/png, rekommenderat förhållande 4:3, storlek högst 5MB',
    gender: 'Sex',
    generalAgreementText: 'Allmän avtalstext',
    generalAlarm: 'Allmänt alarm',
    geofence: 'Elektroniskt stängsel',
    getCarPosition: 'Få fordonets plats i tid',
    getCode: 'Skicka',
    getExchangeRecordsError: 'Det gick inte att hämta inlöshistoriken',
    goCustomPage: 'Gå till anpassad sida',
    goOffline: 'Offline',
    goOnline: 'Online',
    goUrlLink: 'Gå till URL-länk',
    groupTrail: {},
    groupTrailConfig: {},
    guest: 'Ingen bil',
    haveTwo: 'Både och',
    havedWrite: 'Fyllas i',
    havedWriteAll: 'har fyllts i',
    havedWriteAllOrEmpty: 'är ifyllt eller tomt',
    helpAndFeedback: 'Hjälp och feedback',
    helpCenter: 'Hjälpcenter',
    helpConfiguration: 'Hjälpen förklarar konfigurationen',
    helpMessageHistoryDelete: 'Ta bort alla sökposter?',
    helpful: {},
    hint: 'Antydan',
    historyDelete: 'Ta bort alla sökposter?',
    home: 'Hemsida',
    homePage: 'Personlig startsida',
    hour: 'Timme',
    hoursAgo: '%s timmar sedan',
    iWantEnableStoreUserQuery: 'Jag vill aktivera butikens användarsökning',
    iWantToPostStatistics: 'Jag vill publicera statistik',
    identification: 'Identifiering',
    identificationText: 'Identifiering',
    imageSizeExceed: 'Ladda upp en bild med en bredd och höjd på %s',
    imageUploadFailed: 'Det gick inte att ladda upp bilden',
    immediateRelease: 'Omedelbar utgivning',
    immediateSend: 'Skicka nu',
    imporFailedOfTableHeader: 'Import misslyckades. Filhuvud matchade inte',
    import: 'importera',
    importDetails: 'Fråga detaljer',
    importExcel: 'Importera EXCEL',
    importFail: 'Import misslyckades',
    importStatus: 'Status för import',
    importSuccessful: 'Importen lyckades',
    importTemplate: 'Importera mall nedladdning',
    importer: 'importör',
    importerAccountOperationRecord: 'Importörkontots aktiviteter och inloggningsregister',
    importerAvatar: 'Importörens avatar',
    importerDisplayName: 'Visningsnamn för importören',
    importerEnquiry: 'Förfrågan från importören',
    importerManagement: 'Importörshantering',
    importerOperationRecords: 'Importörens operationsregister',
    importing: 'Importerar...',
    inProcess: 'motåtgärder',
    inProgress: 'pågående',
    individualCenter: 'Individuellt centrum',
    informationCategory: 'Informationskategori',
    informationCategoryList: 'Lista över informationskategorier',
    informationCategoryQuery: 'Informationskategorifråga',
    informationContent: 'Informationsinnehåll',
    informationContentList: 'Informationsinnehållslista',
    informationCotnentQuery: 'Fråga om informationsinnehåll',
    informationCover: 'Informationsomslag',
    informationDetails: 'Information Detaljer',
    informationImage: 'omslagsbild',
    informationManagement: 'Informationshantering',
    informationTitle: 'Informationstitel',
    informer: 'Visselblåsare',
    informerId: 'ID för visselblåsare',
    initialPassword: 'Initialt lösenord',
    inputAgreementContent: 'Vänligen ange innehållet i avtalet',
    inputCannotExceed20000: 'Ange upp till 20000 tecken',
    inputErrorEmoji: 'Vänligen ange inte uttryckssymboler',
    installDeviceYouCan: 'Genom att installera den här enheten kan du',
    installVehicleModelAdd: 'Lägg till Beskrivning av eftermonterad fordonsmodell',
    installVehicleModelDescription: 'Beskrivning av den eftermonterade modellen',
    installVehicleModelEdit: 'Redigera Beskrivning av eftermonterad fordonsmodell',
    instrumentLastedVersion: 'TFT-skärm behöver inte uppgraderas',
    instrumentupgrade: 'Uppgradering av TFT-skärm',
    inteligentServiceReminder: 'Grundläggande tjänster för fordonsdata-påminnelse',
    intelligentInternetServiceIntroduction: 'Tjänsteintroduktion',
    intelligentServiceAgreement: 'Avtal om intelligent tjänst',
    intelligentServices: 'Intelligenta tjänster (fordonsinformation, kördata, OTA-uppdateringar)',
    introText: {},
    introduction: 'Introduktion',
    invalidVercode: 'Ogiltig verifieringskod',
    invoicePreview: 'Förhandsgranskning av faktura',
    invoicing: 'Fakturering',
    invoicingFailed: 'Fakturering misslyckades',
    invoicingSucceeded: 'Fakturering lyckades',
    iovNotice1: 'Ovanstående funktioner är baserade på fordonsnätverksenhet (T-Box), kontakta den lokala återförsäljaren för att köpa och installera',
    iovNotice2: 'Ovanstående funktioner är olika beroende på konfigurationen för varje modell och regionen där den finns. Kontakta den lokala återförsäljaren för mer information.',
    iovNotice3: 'Vänligen spara och anteckna enhetsnumret i förväg, vilket krävs vid bindning av enheten. Efter avslutad bindning och installation kan du uppleva fler funktioner',
    isHelpful: 'Hjälper det?',
    isStop: {},
    isSupportedChildOwnerOffMapDown: {},
    isSupportedNoOwnerOffMapDown: {},
    isSupportedOffMapDown: {},
    it_IT: 'italienska',
    iterativeVehicleFunctions: 'Fordonets huvuddelar kan uppgraderas online på distans för att kontinuerligt itera fordonsfunktioner',
    jumpSettings: 'Hoppinställningar',
    jumpTarget: {},
    jumpToWeb: {},
    jumpUrl: {},
    justNow: 'Just nu',
    keySharing: 'Digital nyckel och nyckeldelning',
    kolUser: 'KOL-användare',
    kolUserList: 'Lista över KOL-användare',
    kolUserManagement: 'Hantering av KOL-användare',
    kolUserQuery: 'Förfrågan om KOL-användare',
    language: 'Språk',
    language1: 'Relevant språk',
    languages: 'språk',
    lastLoginTime: 'Senaste inloggningstid',
    lastModifiedBy: 'Senast ändrad av',
    lastUpdateTime: 'Senast uppdaterad tid',
    latitude: 'Latitud',
    launchActivity: 'Starta aktiviteten',
    likeNumber: 'Gillar',
    linkAddress: {},
    linkUrlDescription: {},
    linkedOrder: 'Kopplad beställning',
    listDisplayImages: 'Listvisning',
    listOfImporters: 'Lista över importörer',
    listOfQuestion: {},
    listShowStoreCoverPic: 'Lista visa butikens omslagsbild',
    loadMore: 'Ladda fler',
    loadSuccess: 'Laddningen är klar',
    loading: 'Läser in',
    locationFail: {},
    log: 'Logga',
    login: 'Logga in',
    loginCountry: 'Inloggningsland/region',
    loginSuccessfully: 'Logga in framgångsrikt',
    logout: 'Logga ut',
    longitude: 'Longitud',
    loosing: 'Uppfriskande data...',
    lowCompatibleVersion: 'Minsta kompatibel version',
    mail: 'E-post',
    male: 'Manlig',
    manualReviewStatus: 'Status för manuell granskning',
    mapManage: {},
    marketDataOfdealerStores: 'Marknadsdata för återförsäljarens butiker',
    masteringCyclingData: 'Master riddata',
    maximum: 'Max.',
    maximumBannerCountTip: 'Maximalt %s banners kan vara online samtidigt. Ta bort minst en först.',
    maximumMileage: 'Maximalt inlösningsbar körsträcka',
    maximumValue: 'Högst',
    menuFunctionName: 'Menyfunktions namn',
    menuIcon: 'Menyikon',
    messagePush: 'Meddelandepush',
    messagePushDeleteAsk: 'Är du säker på att du vill ta bort denna push?',
    messagePushDownloadTemplate: 'Vänligen ladda ner mallen först och ladda upp filen efter att du har fyllt i mallfilen. Filstorleken är begränsad till 2M. Om inlämningen misslyckas, vänligen minska innehållet lämpligt',
    messageWithdrawAsk: 'Vill du dra tillbaka denna push?',
    middle: 'mitten',
    min: 'Min',
    minAgo: '%s minuter sedan',
    minimum: 'Min.',
    minimumValue: 'Minsta',
    modelDetail: 'Modelldetaljer',
    modifyFail: 'Ändring misslyckades',
    modifyPassword: 'Ändra lösenord',
    modifySuccess: 'Ändringen lyckades',
    monday: 'Måndag',
    more4pic1video: 'Maximalt 4 bilder / 1 video',
    moreDetailsConsultDealerStore: 'För mer information, kontakta din återförsäljare',
    morning: 'morgon',
    motoPlay: 'MotoPlay (Google-baserad navigering och spegling av skärm)',
    motoPlayAgreement: 'Status för MotoPlay-avtalet',
    motoplatNavigationScreen: 'MotoPlay – spegling och navigering',
    motoplayServicePay: 'Betalning för MotoPlay',
    motoplayServiceResetTimeRule: 'MotoPlay återställningstid kan inte vara senare än den aktuella tiden',
    motorcycle: 'tvåhjuling',
    moveDown: 'Flytta nedåt',
    moveLongPressMap: {},
    moveMapSelectPoint: {},
    moveTo: 'Flytta till',
    moveToBottom: 'Flytta till botten',
    moveToTop: 'Flytta till toppen',
    moveToTopStatus: 'Fäst inlägget',
    moveTop: 'Populära inställningar',
    moveUp: 'Flytta upp',
    multimedia: 'Multimedia',
    mustInteger: {},
    mute1Day: 'Tystnad i 1 dag',
    mute2Days: 'Tystnad i 2 dagar',
    mute30Days: 'Tystnad i 30 dagar',
    mute3Days: 'Tystnad i 3 dagar',
    mute7Days: 'Tystnad i 7 dagar',
    muting: 'Stum',
    nameOfImporter: 'Importörens namn',
    navigation: 'Kartnavigering',
    nearLoginTime: 'Senaste inloggningstid',
    needPopup: 'Behöver popup-fönster',
    negativeNum: 'Dålig recension',
    networkException: 'Nätverk undantag',
    newAddFail: 'Tillägg misslyckades',
    newAddSuccess: 'har lagts till',
    newBanner: 'Nya banners',
    newCancellationAgreement: 'Nytt uppsägningsavtal',
    newEmail: 'Ny e-post',
    newEmailEqualsValidate: 'Den nya e-postadressen kan inte vara densamma som den gamla e-postadressen',
    newFunctionIntro: {},
    newMenuFunction: 'Ny menyfunktion',
    newModelSeries: 'Ny modellserie',
    newPassword: 'Nytt lösenord',
    newPasswordNotEqual: 'Det nya lösenordet som angetts två gånger är inkonsekvent, vänligen ange det igen',
    newQuestionType: {},
    newStoreNumber: 'Antal nya butiker',
    newTopic: 'Nytt tema',
    newUnbindingCommitment: {},
    nextStep: 'Nästa',
    nickName: 'Smeknamn',
    no: 'Nej',
    noContent: 'Inget relaterat innehåll',
    noContent2: 'Föreslå att du ändrar sökord eller',
    noData: 'Inga data',
    noExchangeRecord: 'Inga inlösenposter ännu',
    noFeedbackRecord: 'För närvarande finns det inga återkopplingsregister.',
    noJump: 'Inget hopp',
    noLog: 'Ingen logg',
    noMores: 'Inga fler',
    noNeedPopup: 'Inga popup-fönster krävs',
    noOkToFeedback: 'Oupplöst, jag vill ge feedback',
    noOwnerScore: 'Icke-ägarbetyg',
    noPass: 'Avvisa',
    noSendPeople: 'Ingen avsändare',
    noSortingPermission: 'Ingen sorteringsbehörighet',
    noSupportMapDown: {},
    noThisPermission: 'Inget tillstånd för denna operation',
    noUserSelected: 'Ingen användare har valts, kan inte skicka',
    nofiledSeviceContent: {},
    nonOwner: 'Icke-ägare',
    nonVehicleOwnerCharged: {},
    none: 'Ingen',
    normal: 'Normal',
    notAllowImageAndVideo: 'Video kan inte väljas när du väljer bilder',
    notAllowed: 'Inte tillåtet',
    notBeLessOrEqual: 'Skall inte vara mindre än eller lika med',
    notDeleted: 'Ej inloggad',
    notDistributedYet: 'Ej utfärdad än',
    notEnabled: 'Inte aktiverad',
    notHelpful: {},
    notLessThan: 'Får inte vara mindre än',
    notRecommended: 'Rekommenderas inte',
    notReleasedYet: 'Den har ännu inte släppts',
    notStarted: {},
    'notSupportT-Box': 'Tyvärr stöder ditt fordon inte T-Box',
    notTop: 'Nådde inte toppen',
    notice: 'Lägga märke till',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. We are committed to enhancing service quality and implementing innovative improvements, and we have made business adjustments due to this commitment. As of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In its place, we have launched the brand-new CFMOTO RIDESYNC App. We hope you continue to enjoy our services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Alla versionsnummer kan inte vara 0',
    obtainVerificationCode: 'Hämta verifieringskod',
    officiaAndKolList: 'Officiell/KOL-lista',
    officialAccount: 'Officiellt konto',
    officialAccountAuth: 'Autentisering av officiellt konto',
    officialIrKOLSearch: 'Officiell/KOL-sökning',
    officialKolAuth: 'Officiell/KOL-autentisering',
    offline: 'Off-line',
    offlineAlready: 'Off-line',
    offlineTime: 'Offline-tid',
    offlineTimeMustBeGreaterThan: 'Offlinetiden måste vara större än',
    ok: 'OK',
    oldPassword: 'Gammalt lösenord',
    onLineAlready: {},
    oneMonths: 'En månad',
    oneYear: 'Ett år',
    online: 'Uppkopplad',
    onlyFourWheel: 'Endast fyrhjuliga',
    onlyTwoWheel: 'Endast tvåhjuliga',
    openEveryCount: {},
    openEveryDay: {},
    openProductType: {},
    operationRecord: 'Driftslogg',
    operationTime: 'Driftstid',
    operations: 'Operationer',
    operator: 'Operatör',
    operattor: 'Operatör',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Valfri uppdatering',
    orderFeedBackNum: 'Antal Feedback för beställning',
    orderList: {},
    orderMange: {},
    orderNum: {},
    orderQuestion: 'Beskriv tidpunkten och detaljerna för problemet och ladda upp en eller flera skärmbilder som visar problemet. Vid betalningsproblem, ladda även upp underlaget för debiteringen',
    originalEmail: 'Original e-post',
    otaUpgradeVehicle: 'OTA uppgraderingsfordon',
    otaUpgradeVehicleDesc: 'Fordonets huvudkomponenter kan uppgraderas på distans för att kontinuerligt upprepa fordonets prestanda.',
    other: 'Annan',
    over: 'över',
    owner: 'Ta en bil',
    ownerIdHomepageImage: 'Huvudsidan av ID-kort, körkort eller pass som innehåller personlig identifikationsinformation.',
    parameterConfiguration: 'Parameterkonfiguration',
    partialImportFailed: 'Delvis import misslyckades',
    pass: 'Godkänn',
    passValidateDeleteAccount: 'Identitetsverifieringen har lyckats! Klicka på knappen Skicka begäran längst ner för att begära borttagning av konto',
    password: 'Lösenord',
    passwordRuleText: '8-20 tecken, måste innehålla stora och små engelska bokstäver, siffror, specialtecken',
    passwordRules: 'Lösenordsregler',
    paySetting: {},
    payStrategy: {},
    paymentLastDayBasedata: 'Standardutgåva Betald Varaktighet',
    paymentLastDayMotoplay: 'Motoplay Betald Varaktighet',
    peleaseEnterProvince: 'Vänligen ange en provins/stat',
    pendSend: 'I väntan på',
    pending: 'Avvaktar.',
    pendingSubmit: 'Väntar på inlämning',
    permanentMuting: 'Permanent avstängd',
    phoneModel: 'Modellnummer',
    phoneNum: 'telefonnummer',
    phoneNumber: 'Telefonnummer',
    phoneOrEmail: 'Telefonnummer/E-mail',
    phoneOrEmailImportTemplate: 'Importmall för mobilnummer/e-postadress',
    phoneOrEmailNotRegistered: 'Detta mobilnummer eller denna e-postadress är inte registrerad',
    phoneOrEmailOrUserId: 'Mobiltelefonnummer/e-postadress/användar-ID',
    picture: 'Bild',
    pl_PL: 'putsa',
    pleaseAddImage: 'Lägg till bildfiler',
    pleaseAddVideoFile: 'Lägg till videofiler',
    pleaseEnter: 'Vänligen ange',
    pleaseEnterAccountInfo: 'Ange kontoinformation',
    pleaseEnterAmount: {},
    pleaseEnterCity: 'Vänligen ange en stad',
    pleaseEnterEmail: 'Var god skriv in din e-postadress',
    pleaseEnterEmailAdress: 'Vänligen ange e-postadress',
    pleaseEnterIntro: 'Ange introduktion',
    pleaseEnterLatAndLong: 'Ange latitud och longitud',
    pleaseEnterNewPassword: 'Ange det nya lösenordet',
    pleaseEnterPassword: 'Vänligen ange lösenord',
    pleaseEnterPhone: 'Vänligen skriv in ditt telefonnummer',
    pleaseEnterQuestionDescription: 'Ange en beskrivning av ditt problem',
    pleaseEnterRealname: 'Ange ditt riktiga namn',
    pleaseEnterRemark: 'Vänligen ange kommentarer',
    pleaseEnterServePhone: 'Vänligen ange telefonnummer för service',
    pleaseEnterStoreAddressDetail: 'Vänligen ange detaljerad adress',
    pleaseEnterStoreIntroduce: 'Vänligen ange butikens presentation',
    pleaseEnterStoreName: 'Vänligen ange butikens namn',
    pleaseEnterStoreRemarkName: 'Vänligen ange butiksanmärkningens namn',
    pleaseEnterTitle: 'Vänligen ange en titel',
    pleaseEnterUsername: 'Ange användarnamn',
    pleaseEnterVercode: 'Vänligen ange verifieringskod',
    pleaseEnterVersion: 'Ange versionsnummer',
    pleaseEnterVersionIntroduction: 'Vänligen ange versionsintroduktion',
    pleaseEnterVideoDetail: 'Vänligen ange videoinformation',
    pleaseEnterVin: 'Vänligen ange VIN',
    pleaseInputWord: 'Vänligen ange nyckelord',
    pleaseLoginFirst: 'Snälla logga in först',
    pleaseRepeatNewPassword: 'vänligen upprepa det nya lösenordet',
    pleaseSelect: 'Vänligen välj',
    pleaseSelectAuthAccount: 'Välj autentiseringskonto',
    pleaseSelectBusinessHours: 'Vänligen välj öppettider',
    pleaseSelectCity: 'Vänligen välj stad',
    pleaseSelectCountry: 'Vänligen välj land',
    pleaseSelectCurrency: {},
    pleaseSelectMatchingMultimediaContent: 'Välj det matchande multimediainnehållet',
    pleaseSelectPayChannel: {},
    pleaseSelectProblemWhere: 'Välj ett scenario där problemet uppstår',
    pleaseSelectProducType: {},
    pleaseSelectProvince: 'Vänligen välj provins/delstat',
    pleaseSelectQueType: 'Vänligen välj typ av fråga',
    pleaseSelectReportReason: 'Vänligen välj orsak till rapportering',
    pleaseSelectService: 'Vänligen välj en tjänst först',
    pleaseSelectStatus: 'Vänligen välj status',
    pleaseSelectStoreType: 'Vänligen välj typ av butik',
    pleaseSelectTimedSendTime: 'Välj sändningstid',
    pleaseSelectUserTheList: 'Välj en användare från listan',
    pleaseSelectVehicle: 'Välj ett fordon',
    pleaseSelectVehicleConfig: {},
    pleaseSelectlinkedOrder: 'Vänligen välj en kopplad beställning.',
    pleaseSelectupgradeType: 'Vänligen välj uppdateringsmetoden',
    pleaseSureType2: 'Se till att allt i',
    pleaseUpload: 'Ladda upp',
    pleaseUploadPicVideo: 'Vänligen ladda upp bilder/videor',
    pleaseUserTimeFill: 'Vänligen fyll i enligt slutanvändarens tid',
    popUpFrequencyType: 'Popup-fönsterformulär',
    popUpFrequencyValue: 'Popup-frekvens',
    popUpFrequencyValueValid: 'Välj frekvensdagar',
    popUpReminder: 'Om en påminnelse ska dyka upp',
    popupArea: 'popup-användarutbud',
    popupCreate: {},
    popupDayOne: 'En gång per antal dagar',
    popupEdit: {},
    popupFrequency: {},
    popupManagement: {},
    popupOne: {},
    popupPosition: {},
    popupStatus: {},
    popupTarget: {},
    popupTime: {},
    popupTitle: {},
    positiveNum: 'Bra recensioner',
    postComment: 'Lämna en kommentar',
    postContent: 'Innehållet i inlägget',
    postId: 'Post-ID',
    postList: 'Lista över inlägg',
    postManagement: 'Hantering av inlägg',
    postSearch: 'Inläggssökning',
    posts: 'Inlägg',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Sekretesspolicy Innehållsinformation',
    privacyPolicy: 'Integritetspolicy',
    privacyPopupAgree: 'Få tillbaka användarens samtycke till integritetspolicyn genom ett popup-fönster',
    privacyVersion: 'Sekretesspolicyversion',
    privacyVersionList: 'Sekretesspolicy versionslista',
    problemaDes: 'Beskrivning av problemet',
    processMethod: 'Metoder för behandling',
    processReason: 'Anledning till behandling',
    processReasonDetails: 'Uppgifter om orsaken till behandlingen',
    processRecord: 'Bearbetning av poster',
    processReport: 'Bearbeta rapporter',
    processSolution: 'Lösningar för maskinbearbetning',
    processUser: 'Hantering av användare',
    processed: 'Bearbetad',
    productDetails: {},
    productTime: 'produktionstid',
    prohibitDecimalsAndNegative: {},
    pt_PT: 'portugisiska',
    publishInformation: 'Publicera information',
    publishPosts: 'Publicera ett inlägg',
    pullBefore: 'Dra ner för att uppdatera.',
    pulling: 'Släpp uppdatering nu',
    purchaseAndInstall: 'Köp och installera',
    pushConfiguration: 'Pushkonfiguration',
    pushContent: 'Push innehåll',
    pushList: 'Pushlista',
    pushMode: 'Pushläge',
    pushNow: 'Pusha nu',
    pushQuery: 'Pushförfrågan',
    pushRecord: 'Push-anteckning',
    pushScope: 'Pushomfattning',
    pushTime: 'Push-tid',
    pushTimeDifferenceAsk: 'Sändningstiden du väljer kan göra att vissa användare inte kan ta emot denna push på grund av tidsskillnader. Är du säker på att du vill spara?',
    pushTitle: 'Pushrubrik',
    pushed: 'Tryckte',
    pushing: 'Pågår pushning',
    quantity: 'Kvantitet',
    query: 'Sök på',
    question: {},
    questionInquiry: {},
    questionType: 'Typ av fråga',
    questionTypeList: {},
    questionTypeTemplate: {},
    quickRelease: 'Snabb frigöring',
    ranking: 'Rankning',
    ratingWarn1: 'För användare av fordonsägare har den smarta tjänstekontrollen som motsvarar landet/regionen i hanteringsbakgrunden inte aktiverats eller så har den smarta tjänstetjänsten inte gått ut efter att ha slagits på. Fordonet är online och har',
    ratingWarn2: 'eller fler fullständiga körrekord (starten och slutet av varje åktur rapporteras händelse), en popup kommer att visas när användaren lämnar My Cycling och återvänder till startsidan.',
    reUpgrade: 'Försök igen',
    readAgree: 'Läs och godkänn',
    readAndAgree: 'Vänligen läs och godkänn',
    readAndAgreeTo: 'Jag har läst och godkänner',
    readDeleteStep: 'förstå vilka typer av data vi kommer att radera eller behålla och eventuella ytterligare lagringsperioder',
    realname: 'Riktiga namn',
    reasonForReport: 'Anledning',
    receiveCarReminderMessage: 'Ta emot meddelanden om fordon',
    rechargeAmount: {},
    rechargeChannel: {},
    rechargeStatus: {},
    rechargeTime: {},
    recharged: {},
    recipients: 'Mottagare',
    recipientsNum: 'Mottagarens omfattning',
    recommended: 'Rekommendera',
    recommendedStatus: 'Rekommenderad status',
    redeemableServiceHours: 'Tjänstetimmar som kan lösas in',
    redemptionMileage: 'Tillgängliga körsträcka att lösa in',
    redemptionRatio: 'Inlösenförhållande',
    redemptionTime: 'Tidpunkt för inlösen',
    redirectUrl: {},
    refreshInterval: 'Uppdateringsintervall',
    refreshSend: 'skicka igen',
    refundFailed: {},
    refunded: {},
    refunding: {},
    refused: 'Avvisad',
    registerDate: 'Tid för registrering',
    rejected: 'Avvisad.',
    releaseContent: 'Publicera innehåll',
    releaseMethod: 'Publiceringsmetod',
    releaseMute: 'Släpp tystnaden',
    releaseTime: 'Releasetid:',
    released: 'Släppa',
    releasedBy: 'Förläggare',
    remainServiceHavExpired: 'Tid kvar tills intelligent tjänst löper ut',
    remainingAvailableMileage: 'Återstående tillgänglig körsträcka',
    remark: 'Anteckningar',
    rememberPassword: 'Kom ihåg lösenordet',
    reminder: 'Påminnelse',
    remove: 'Ta bort',
    removeOnlinUpgrade: 'Fjärr online uppgradering fordon',
    repeatNewPassword: 'Upprepa det nya lösenordet',
    replaceTBOX: 'Byt ut TBOX',
    replied: 'Svarade',
    reply: 'Svara',
    report: 'Rapportera',
    reportList: 'Rapportlista',
    reportManagement: 'Hantering av rapporter',
    reportReason: 'Anledning till rapportering',
    reportReasonDetails: 'Närmare uppgifter om orsaken till anmälan',
    reportReasonPlaceholder: 'Skriv vad du vill rapportera, 0-1500 ord',
    reportSearch: 'Sökning i rapporter',
    reportSuccessful: 'Rapportera framgångsrikt, vi kommer att hantera det så snart som möjligt',
    reportTime: 'Rapportera tid',
    reportType: 'Typ av rapport',
    reportedContent: 'Rapportens innehåll',
    reportedUser: 'Rapportera en användare',
    reportedUserId: 'Användar-ID för rapporten',
    requestTimedOut: 'Begäran tog för lång tid',
    resend: 'Skicka igen',
    resendTo: 'Skicka igen till',
    reset: 'Återställ',
    resetItem: 'Återställningsobjekt',
    resetTime: 'Tid för återställning av smarta tjänster',
    resetWarn: 'Efter återställningen kommer den kostnadsfria perioden för fordonsets smarta tjänster att beräknas om och träda i kraft baserat på den aktuella tiden (webbläsartid). Bekräfta återställning?',
    return: 'Återgå',
    review: 'Granskning',
    reviewApproved: 'Recensionen godkänd',
    richText: {},
    ro_RO: 'rumänska',
    roleDescription: 'Rollbeskrivning',
    roleName: 'Rollnamn',
    rolePermission: 'Rolltillstånd',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'ryska',
    safeRemind: 'För att skydda ditt kontos säkerhet får du inte lämna in känslig personlig information här, t.ex. lösenord till konton osv.',
    satelliteMap: 'Satellitkarta',
    saturday: 'Lördag',
    save: 'Spara',
    saveAndPreview: 'Spara och förhandsgranska',
    saveAsDraft: 'Spara som utkast',
    saveFail: 'Misslyckades med att spara',
    savePicture: 'Spara bild',
    saveSettings: 'Spara inställningar',
    saveSuccess: 'Sparat framgångsrikt',
    saveVideo: 'Spara video',
    scanQrcodePreview: 'Skanna QR-koden nedan med din mobiltelefon för att förhandsgranska',
    screenNavigationGuidance: 'Boot-inställningar',
    sdkStatement: 'SDK-uttalande',
    search: 'Sök',
    searchRecords: 'Historisk sökning',
    secondaryMenu: 'Sekundär meny',
    securityMessage: 'Ovanstående information används endast för identitetsverifiering. CFMOTO skyddar din information.',
    securityServices: 'Säkerhetstjänster (positionering i realtid, geostängsel, felvarning)',
    select: 'Välj',
    selectAccount: 'Välj konto',
    selectAll: 'Välj alla',
    selectAuthentication: 'Välj autentisering',
    selectChannelType: 'Välj en feedbackkanal',
    selectCountry: 'Välj land',
    selectData: 'Välj de uppgifter du vill radera och klicka på knappen Skicka längst ned för att skicka in diniktlinjerna för borttagning av data.',
    selectDate: 'Välj Datum',
    selectEnableStatus: {},
    selectFeedBackState: 'Välj status för bearbetning av feedback',
    selectFeedbackType: 'Välj en typ av feedback',
    selectJumpTarget: {},
    selectLanguage: 'Välj språk',
    selectOneCarType: 'Välj minst en modell',
    selectPoint: {},
    selectPopupFrequency: {},
    selectPopupPosition: {},
    selectPopupTarget: {},
    selectPopupTime: {},
    selectRejectReason: 'Välj en orsak till avslaget',
    selectTheLanguage: 'Välj språk',
    selectTime: 'välj tid',
    selectUser: 'Välj användare',
    selectVehicle: 'Välj fordon',
    selectedMileage: 'Vald körsträcka',
    selectedMileageRedemption: 'Välj antal körsträcka att lösa in',
    selectionOfImporter: 'Val av importör',
    sendNumberDescription: 'Antal giltiga enheter där AWS Cloud skapade sändningsuppgifter;',
    sendNumberDescription0: 'Bland de effektiva målgrupsenheterna skapar Aurora-servern faktiskt antalet enheter för att skicka uppgifter',
    sendNumberVolume: 'Antal sändningar',
    sendTo: 'Skicka till',
    sendType: 'Skicka läge',
    sendUserNum: 'Antal sändningar',
    sending: 'I att skicka',
    serial: 'Nej.',
    seriesBackground: {},
    seriesDesc: {},
    seriesIntroduction: 'Serieinformation',
    seriesName: {},
    seriesShowcase: 'Serieuppvisning',
    seriesUplodImgRule: {},
    seriousAlarm: 'Allvarligt larm',
    serviceDays: 'Tjänstedagar',
    serviceDetail: 'Detaljer om Intelligenta Tjänster',
    serviceExpiration: 'Dina intelligenta tjänster har löpt ut',
    serviceHavExpired: 'Intelligenta Tjänster Har Upphört',
    serviceIntroduction: 'Tjänsteintroduktion',
    serviceReset: 'Återställning av Intelligent Tjänst',
    serviceText: 'Tjänster',
    settingSuccess: 'Ställ in framgångsrikt',
    shareNumber: 'Antal delningar',
    sheet: 'Zhang',
    show: 'Utsikt',
    showPicturesOfVideos: 'Visa bilder/filmer',
    showToast1: 'För lite körsträcka för 1 dags tjänst',
    showToast2: 'Minst 1 dags tjänst krävs för inlösen',
    showToast3: 'Parametern finns inte eller är tom',
    showroomModel: 'Showroom modeller',
    showroomModelList: 'Showroom modelllista',
    showroomModelQuery: 'Förfrågan om modellutställning',
    showroomUploadRules: 'Kravet på bildformat är jpg/jpeg/png, bildförhållandet är 9:19,5, storleken överstiger inte 5 MB och videostorleken överstiger inte 50 MB',
    signOut: 'Avslutas automatiskt',
    singapore: 'Singapore',
    sixMonths: 'Sex månader',
    slideToRight: 'svep åt höger',
    smartServices: 'Smarta tjänster',
    someUser: 'Vissa användare',
    sort: 'Typ',
    source: 'Källa för data',
    sr_YU: 'serbiska',
    standardAgreement: 'Status för Standard Edition-avtalet',
    startCalculateTimeBasedata: 'Återställningstid för Standardutgåva',
    startCalculateTimeMotoplay: 'Återställningstid för Motoplay',
    startChecking: 'Starta kontroll',
    startTime: 'Starttid',
    statisticalTime: 'Statistisk tid',
    status: 'Status',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: {},
    store: {},
    storeAddressCountryTip: 'Observera:  Denna butiksadress är den enda grunden för användare att hitta dig.  Vänligen fyll i noggrant och se till att adressen är korrekt',
    storeAddressDetail: 'Butikens adress',
    storeAddressDetailTip: 'Exempel: detaljerad adress:  NO.116, Wuzhou Road, Yuhang Economic Development Zone, Hangzhou',
    storeAddressPosition: 'Latitud och longitud',
    storeAddressPositionTip:
      'Longitud: heltalsdelen av longituden är ett heltal från -180 till 180, och decimaldelen är en decimal med högst 15 siffror.\nLatitud: heltalsdelen av latitud är ett heltal från -90 till 90, och decimaldelen är högst 15 decimaler.',
    storeBusinessType: 'Typ av butik',
    storeImage: 'Bild från butik',
    storeImportTemplateText: 'Ladda ner mallen, fyll i återförsäljarens butiksinformation i mallfilen och ladda sedan upp filen; filstorleken är begränsad till 1 MB; om uppladdningen misslyckas, minska innehållet eller ladda upp i omgångar',
    storeIntroduce: 'Introduktion till butiken',
    storeList: 'Lista över butiker',
    storeMange: 'Butikens ledning',
    storeName: 'Butikens namn',
    storeNameTip: 'Observera: Vänligen välj det språk som stöds av systemet för att fylla i butiksnamnet',
    storeQueryUserStatistics: 'Statistik för användarfrågor i butik',
    storeRemarkName: 'Namn på anmärkning',
    storeRemarkNameTip: 'Observera:  Om språken som stöds av systemet inte uppfyller dina behov kan du ange butiksanmärkningens namn på det språk du vill här.',
    storeSearch: 'Sök efter butiker',
    storeServicePhone: 'Telefonnummer till tjänsten',
    storeServicePhoneTip: 'Observera: Det här numret är för kundtelefonkontakt, se till att telefonnumret är korrekt.',
    storeServiceTime: 'Öppningstid',
    storeStatistics: 'Butiksstatistik',
    storeUploadImageRequire: 'Krav på bildformat för jpg/jpeg/png, det rekommenderas att storleken på en enda bild inte överstiger 5 MB, en enda import på upp till 9, kan importeras mer än en gång, det totala antalet inte mer än 9',
    storefront: 'Butik',
    submissionFailed: 'Misslyckades att skicka in, försök igen.',
    submit: 'Skicka in',
    submitAccountDeleteApply: 'Skicka in Riktlinjer för borttagning av konto',
    submitDataDeleteApply: 'Skicka in en begäran om radering av data',
    submitFeedback: 'Skicka feedback',
    submitForReview: 'Skicka för granskning',
    submitted: 'Inlämnad',
    successful: 'Framgångsrik',
    sunday: 'Söndag',
    supportMapDown: {},
    supportedChannel: {},
    sureAgree: 'Håller med eller inte?',
    sureBackApply: 'Bekräfta återkallande av ansökan om borttagning av konto',
    sureDelete: 'När den har raderats kan den inte återställas. Är du säker på att du vill ta bort den',
    sureDeleteData: 'Är du säker på att du vill radera de valda uppgifterna? När du har bekräftat kommer data att raderas omedelbart och kan inte återställas',
    sureDeleteSeries: {},
    sureDeleteSetting: {},
    sureDeleteStoreInfo: 'Bekräfta radering av denna butiksinformation? Efter radering kommer informationen inte att kunna återskapas',
    sureReject: 'Är du säker att du vill ta bort?',
    sureSuspend: 'Sändningen upphör efter avslutad. Är du säker på att du vill avsluta',
    suspend: 'Avsluta',
    sv_SE: 'svenska',
    switchLanguage: 'Byt språk',
    system: 'System',
    systemBusy: 'Systemet är upptaget, försök igen senare',
    systemVersion: 'systemversion',
    tboxInstall: 'Tbox – efterinstallation',
    tboxIntro: 'T-Box är nyckeln för att förverkliga fordonens intelligenta nätverksanslutningsfunktion',
    teamConfigTip: {},
    threeMonths: 'Tre månader',
    thursday: 'Torsdag',
    time: 'Tid',
    timeSend: 'Tidsinställd sändning',
    timedOffline: 'Schemalagd offline',
    timedPush: 'Tidsinställd push',
    timedRelease: 'Schemalagd publicering',
    timedSendTime: 'Skicka tid',
    tips: 'Tips',
    title: 'titel',
    to: 'Till',
    toBeReleased: 'Kommer snart',
    topMenu: 'Toppmeny',
    topicContent: 'Ämnets innehåll',
    topicList: 'Lista över ämnen',
    topicManagement: 'Hantering av teman',
    topicSearch: 'Sökning av ämnen',
    topicTitle: 'Ämnets titel',
    totalAndlLayoutOfStores: 'Totalt antal och fördelning av butiker',
    totalClicks: {},
    totalNumber: 'Totalt antal gånger',
    tr_TR: 'turkiska',
    triggerNum: 'Antal triggers',
    tuesday: 'Tisdag',
    turnOn: 'Öppna',
    twoCarAndFourCarOfNumber: 'Antal användare av två- och fyrhjuliga fordon',
    twoCarOfNumber: 'Antal användare av tvåhjuliga fordon',
    twoWheelConfig: {},
    twoWheeler: 'Tvåhjuling',
    twoWheelerAndFourWheeler: 'Tvåhjulingar och fyrhjulingar',
    twoWheelerMostClicks: 'Tvåhjuliga fordonsmodeller med flest klick',
    twoWheelowner: {},
    type: 'Typ',
    typeMessage: 'typ av feedback',
    types: 'Typ',
    unbind: 'Obunden',
    unbindingCommitment: {},
    unbindingLabelRealName: 'Ditt fulla namn',
    unbound: 'Ej bunden.',
    understandRealtimeConditions: 'Ta emot fordonsvibrationer och elektroniska stängslets in- och utfartspåminnelser och förstå fordonets status i realtid',
    uninstallTboxDesc: 'För fordon som inte har en T-Box installerad kan du se grundläggande fordonsinformation som ramnummer, motornummer och elektronisk manual efter bindning.',
    unitCurrencyPer: {},
    unitMonth: 'Månad',
    unlimited: 'Obegränsat',
    unpaid: {},
    unprocessed: 'Obehandlad',
    unresolved: 'Kan du fortfarande inte lösa? Klick',
    unspecified: 'Sekretess',
    upToTopics: 'Du kan lägga till upp till %s ämnen',
    updateAuthenticationTime: 'Uppdatera autentiseringstid',
    updateBy: 'Uppdatering',
    updateSuccess: {},
    updateTime: 'Uppdateringstid',
    updating: 'uppdatering',
    upgradeAgainDescription: 'Uppgraderingsuppgiften har flyttats på nytt. Vänligen följ 【Guiden】 överst på den aktuella sidan för att ansluta tft-displaynätverket för att uppgradera.',
    upgradeAssistant: 'Hjälp',
    upgradeDescription: 'När en ny version hittas, följ 【Guiden】 längst upp på den aktuella sidan för att ansluta tft-displaynätverket för att uppgradera.',
    upgradeSuccessful: 'Uppgraderingen lyckades',
    upgradeType: 'Uppdateringsmetod',
    upload: 'Ladda upp',
    uploadDisplayPicture: {},
    uploadFail: 'Uppladdning misslyckades',
    uploadFailed: 'Uppladdningen misslyckades, försök med ett annat nätverk',
    uploadFailedOfTry: 'Uppladdningen misslyckades, försök igen',
    uploadFileMore1M: 'Filstorleken för uppladdning överstiger inte 1M',
    uploadFiles: 'Ladda upp fil',
    uploadImageRules1To1: 'Bildformatet måste vara jpg/jpeg/png, med ett bildförhållande 1:1 och en maximal storlek på 5MB',
    uploadLog: 'Ladda upp logg',
    uploadPicture: 'Ladda upp bild',
    uploadQuantityExceed: 'Antalet uppladdningar överskrider gränsen',
    uploadSuccessful: 'Ladda upp lyckad',
    uploadTime: 'Uppladdningstid',
    uploadTip556_740: {},
    uploadVideoRules: 'Endast enskild uppladdning av videofiler stöds. Det rekommenderas att storleken på en enskild video inte överstiger 50 MB.',
    uploadVideoRules4To3: 'Stöd videoformat, rekommenderat förhållande på 4:3, storlek som inte överstiger 50 MB',
    urlLink: 'URL-länk',
    user: 'Användare',
    userAccount: 'Användarkonto',
    userEmail: 'E-post',
    userGender: 'Användarkön',
    userId: 'Användar-ID',
    userIdTemplate: 'Importmall för användar-ID',
    userIdentity: 'användar ID',
    userLocalTime: 'Sluttid för slutanvändare',
    userLogin: 'Logga in',
    userMobilePhone: 'mobiltelefonnummer',
    userModel: 'Användarmodell',
    userName: 'Användarnamn',
    userName1: {},
    userNickname: 'Användarens smeknamn',
    userNum: 'Användarnummer',
    userPhone: 'mobilnummer',
    userRealName: 'Användarens riktiga namn',
    userReply: 'Väntar på användarsvar',
    userStatus: 'Status för användare',
    userType: 'Användartyp',
    userUnbind: 'Användaren avbinder',
    users: 'användare',
    vacationTime: 'Semestertid',
    validNumberVolume: 'Antal giltiga mål',
    validNumerDescription: 'Antal enheter som återstår efter filtrering av den valda målgruppen för push-uppgiften',
    validateAfter24Hours: 'Stöder endast framtida tidsval inom 24 timmar',
    validateEmail: 'Felaktigt format på e-postadressen, var vänlig kontrollera.',
    validateImageRadio: 'Krav för bildfilformat:  %s, bildförhållande:  %s, inte till mer än %s',
    validateImageSize: 'Krav för bildfilformat:  %s, rekommenderad bildstorlek:  %s, inte till mer än %s',
    validatePhone: 'Fel i formatet på telefonnumret, kontrollera',
    validateVideo: 'Krav för videofilformat:  %s, inte till mer än %s',
    validateVin: 'Felaktig VIN, vänligen kontrollera.',
    validationCodeError: 'Verifikationskodfel',
    vechicleFirstBindTime: 'Fordonets faktiska första bindningstid',
    vehicleAlarmDetails: 'Information om fordonslarm',
    vehicleBindDuration: 'Fordonsbindningens varaktighet',
    vehicleBrochure: 'Fordonsbroschyr',
    vehicleColor: 'Fordonets färg',
    vehicleDetails: 'Fordonsdetaljer',
    vehicleDrivingLicense: 'Fordonsregistreringsbevis.',
    vehicleFaultDetails: 'Detaljer om fordonshaveri',
    vehicleGallery: 'Bilgalleri',
    vehicleGalleryEntranceConfiguration: 'APP motorcykelutställningssidan och fordonsgalleriets ingångsbilder är alla tagna från följande konfiguration. Se till att de tre bilderna är kompletta i konfigurationen.',
    vehicleGalleryEntranceSettings: 'Inställningar för fordonsgalleriet',
    vehicleGalleryUploadRules: 'Kravet på bildformat är jpg/jpeg/png. Det rekommenderas att storleken på en enskild bild inte överstiger 5 MB. Maximalt 10 bilder kan importeras åt gången. Flera importer är tillåtna.',
    vehicleIdHomepageImage: 'Fordonsregistreringsbevisets huvudsida med ägarens namn och VIN.',
    vehicleModel: 'Fordonsmodell',
    vehicleModelAlbum: 'Modellalbum',
    vehicleModelCategorySort: 'Sortera efter fordonskategori',
    vehicleModelDescription: 'Modellbeskrivning',
    vehicleModelList: 'Modelllista',
    vehicleModelManagement: 'Hantering av fordonsmodeller',
    vehicleModelName: 'Modellnamn',
    vehicleModelQuery: 'Fråga om fordonsmodell',
    vehicleModelSeries: 'Modellserie',
    vehicleModelSorting: 'Modellsortering',
    vehicleModelType: 'Modell typ',
    vehicleName: 'Fordonets namn',
    vehicleNetworkEquipment: 'Fordonsnätverksenhet',
    vehicleOutboundCountry: 'Fordonets utresande land',
    vehicleRemark: 'Fordonsanmärkningar',
    vehicleShareInstruction: 'Instruktioner för delning av fordon',
    vehicleShareInstructionAdd: 'Instruktioner för delning av nya fordon',
    vehicleShareInstructionEdit: 'Redigera instruktioner för fordonsdelning',
    vehicleType: 'Motor nr.',
    vehicleTypeSplicing: 'Modell för återkoppling',
    vehicleUnbindingInstructions: 'Anvisningar för att ansöka om fordonsfrigörande',
    verifyCodeSendFail: 'Det gick inte att skicka verifieringskoden',
    verifyCodeSendSuccess: 'Verifieringskoden har skickats',
    versionCode: 'Versionsnummer',
    versionIntroduction: 'Version Introduktion',
    versionManage: 'Versionshantering',
    versionManageList: 'Versionshanteringslista',
    versionMangeTip:
      'Obs: Det är inte tillåtet att skapa en version som är större än det versionsnummer som för närvarande finns på appmarknaden! Drift- och underhållspersonal måste vänta på att den senaste versionen släpps på Google Play eller App Store och sedan skapa versionsposter som motsvarar det senaste versionsnumret. Det är inte tillåtet att skapa poster i förväg.',
    versionPattern: 'Versionsnumret kan endast anges som ett heltal från 0 till 999.',
    versionRequired: 'Versionsnumret får inte vara tomt',
    vhDataBasicService: 'Fordonsdata Grundläggande tjänst',
    video: 'Video',
    videoContent: 'Videoinnehåll',
    videoCover: 'Videoomslag',
    videoDetail: 'Videodetaljer',
    videoDisplayImages: 'Videovisning',
    videoFile: 'Videofil',
    videoGuide: 'Konfiguration av videostart',
    videoImageValidate: 'Krav på bildfilformat: png jpg jpeg, bildförhållande 16:9, storlek högst 5 MB',
    videoList: 'Videolista',
    videoMaxSizeValidate: 'Videostorleken får inte överstiga 150 MB',
    videoSizeExceed: 'Ladda upp en video med en bredd och höjd på %s',
    viewAllComment: 'Se alla recensioner',
    viewCount: 'antal visningar',
    viewCurrentLocation: 'Öppna APP för att se den aktuella platsen för fordonet när som helst',
    viewCurrentLocation2: 'Öppna APP för att se fordonets aktuella position när som helst, vilket är bekvämt för att hitta fordon på nära håll',
    viewDetails: 'Visa detaljer',
    viewFeedBackRecords: 'Visa återkopplingsposter',
    viewLocation: 'Öppna APPEN för att kontrollera fordonets plats när som helst',
    viewModel: {},
    viewPush: 'Visa tryck',
    viewSeries: {},
    viewVehicleInfomation: 'Stöd för att se den dagliga körbanan, körsträcka, varaktighet, hastighet och annan information om fordonet',
    views: 'Visningar',
    vin: 'VIN',
    virginia: 'Virginia',
    waitForReview: 'Väntar på granskning',
    waitUploading: 'Uppladdning, vänligen vänta',
    waitingManualReview: 'Väntar på manuell granskning',
    waitingOnline: {},
    waitingPush: 'Väntar',
    wednesday: 'Onsdag',
    whatOTA: 'Vad är OTA?',
    whyUseNavigation: 'Hur man använder navigeringen',
    whyUseSetting: 'Hur man gör allmänna inställningar för APP',
    withCountry: 'Land/region (IP)',
    withInformation: 'Med information',
    withTBOX: {},
    withdrawn: 'Återkallad',
    withoutCarOfNumber: 'Antal användare utan bil',
    withoutTBOX: {},
    writeAccountToPass: 'Fyll i din kontoinformation och slutför identitetsverifieringen',
    year: {},
    yes: 'Ja',
    youHaveFeedbackMessage: 'Du har ** användarfeedback som inte har följts upp effektivt, vänligen ta itu med det i tid',
    youthVehicleOwner: {},
    yoyGrowth: 'Ökat med  År över år',
    zh_CN: 'kinesiska',
  },
};
